export const aboutAkashGangaData = [
  {
    description: `As a digital, proudly Made in India, Open Access Journal
    Platform, we are dedicated to supporting Universities,
    Institutes, and Societies in publishing their journals,
    globally.`,
  },
  {
    description: `Our practices completely adhere to the policies, guidelines, and
    internationally accepted standards on ethical Journal
    Publishing.`,
  },
  {
    description: `With our commitment to affordable publishing and a host of
    exceptional benefits, we aim to be the
    <strong>Partner of Choice</strong> for institutions seeking a
    reliable and efficient publishing platform.`,
  },
];

export const automateSubmissionSystemData = [
  {
    description: `At the heart of Aakashganga’s offering is its fully automated
    submission process. An author writes directly on to our AI
    driven platform. You don’t need to send articles via email or
    upload to servers.`,
  },
  {
    description: `The article editor is divided into customizable sections that
    help researchers submit their article in the sections they
    desire. Each section has an automated Spell Checker, Grammar
    Checker built into it. The content is typeset as you write and
    submit thus saving processing time.`,
  },
];

export const automatePublishingEditorData = [
  {
    description: `The article is immediately sent to 5 Publishing Editors chosen
    by our state of the art matching system. This is completely
    anonymous and transparent. Of the 5 the first to choose to
    perform an editorial review is allotted the paper.`,
  },
  {
    description: `A similar system selects a Peer Reviewer (subject to the
    process chosen) and sends invitation letters to 5 selected
    Peer Reviewers in the system. The Publishing Editor and the
    Publishers have no say in the selection process at this stage.
    The first person to accept the invitation is allotted the
    article.`,
  },
];

export const automatedProfanitySimilarityData = [
  {
    description: `All submissions are checked for any sort of Profanity.
    Turnitin is our partner for Similarity Index checking.`,
  },
  {
    description: `Receive your personal reports within seconds of submitting
    your article.`,
  },
];

export const openPeerReviewData = [
  {
    description: `All articles published on the platform automatically get
    listed for Open Peer Review.`,
  },
  {
    description: `Researchers across the globe can register and review any
    article. The reviews go through the same level of profanity,
    spelling and grammar check. Every article is thus given a fair
    chance to be cited and reviewed transparently.`,
  },
];
